<script>
    import { Newsletter } from "../../../utils/Constant/Constant";
    import BookmarkCommon from "./BookmarkCommon.svelte";
</script>
<BookmarkCommon header={Newsletter} id={"pills-newsletter"}/>